import { PerspectiveCamera } from "three";

class CameraShake {
  private camera: PerspectiveCamera;
  private bounce = 0;
  private shake = 0;

  constructor(camera: PerspectiveCamera) {
    this.camera = camera;
  }

  public update(delta: number, velocity: number): void {
    this.bounce += (1 / 60) * delta * 200 * velocity;
    this.shake += (1 / 60) * delta * 100 * velocity + 0.005;

    this.camera.position.y += Math.sin(this.bounce) * 0.03;
    this.camera.rotation.z += Math.sin(this.shake) * 0.003;
    this.camera.rotation.y += Math.sin(this.shake) * 0.015;
  }
}

export default CameraShake;
